






































import { VFileInput, VChip } from 'vuetify/lib'
import { mdiPaperclip } from '@mdi/js'
import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'base-input-file-picker',
  components: {
    VFileInput,
    VChip
  },
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    label: String,
    color: {
      type: String,
      default: 'primary'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select documents to attach'
    },
    dense: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    }
  },
  setup () {
    const files = ref([])

    return {
      files,
      mdiPaperclip
    }
  }
})
